module.exports = __webpack_public_path__ + "img/down.be5030ca.webp";